export default __webpack_public_path__ + "static/media/admin-icon.ae0b6319.png";